import type { ReactNode } from 'react';
import { Icon } from '@iconify/react';

// Estado vacío: cuando una lista, tabla o gráfico no tiene datos.
// En tablas NextUI va en <TableBody emptyContent={...}>. Ver design.md › Estados.
const EmptyState = ({
  title,
  description,
  icon = 'tabler:inbox',
  action,
  className = '',
}: {
  title: string;
  description?: ReactNode;
  icon?: string;
  action?: ReactNode;
  className?: string;
}) => (
  <div
    className={`flex flex-col items-center gap-2 rounded-lg border border-dashed border-default-200 p-8 text-center ${className}`}
  >
    <Icon icon={icon} className='text-default-400' width={28} />
    <p className='text-sm font-medium'>{title}</p>
    {description ? (
      <p className='max-w-md text-sm text-default-500'>{description}</p>
    ) : null}
    {action ? <div className='mt-2'>{action}</div> : null}
  </div>
);

export default EmptyState;
